module.exports = __webpack_public_path__ + "static/media/periodic-table.3292cb60.svg";